import axios from '.././Utils/Utility/axiosconfig'
import isAuthenticate from '.././Utils/Utility/auth'

export const auctionLotAction = (list) => ({
    type: 'AUCTIONLOTS',
    list,
})

const auctionlotDetails = (body) => {
    return async (dispatch) => {
        try {
            const res = await axios.post('api/auctionLotAPI', body)
            console.log('auctionlotapi', res, body)
            if (res.data.status === 'success') {
                dispatch(auctionLotAction(res.data.response))
            } else {
                return `something went wrong`
            }
        } catch (error) {
            console.log(error)
        }
    }
}

export default auctionlotDetails
